"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const faCheckCircle_1 = require("@fortawesome/free-solid-svg-icons/faCheckCircle");
const faCircle_1 = require("@fortawesome/free-solid-svg-icons/faCircle");
const InputCheckbox_1 = require("../../../input/InputCheckbox");
const Button_1 = require("../../../input/Button");
const react_redux_1 = require("react-redux");
const WidgetSetAdmin = (props) => {
    const { t } = (0, react_i18next_1.useTranslation)(['admin', 'main']);
    const [isAdmin, setIsAdmin] = react_1.default.useState(props.isAdmin === true ? true : false);
    const [modified, setModified] = react_1.default.useState(false);
    const [loading, setLoading] = react_1.default.useState(false);
    const user = (0, react_redux_1.useSelector)((state) => state.auth.user);
    const fetchIdRef = react_1.default.useRef(0);
    // Function to fetch data from the server, with paging and filtering
    const updateCurrentUser = react_1.default.useCallback((isAdmin) => __awaiter(void 0, void 0, void 0, function* () {
        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current;
        // Set the loading state
        setLoading(true);
        try {
            const response = yield fetch('/api/admin/updateUserSetAdmin', {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                method: 'POST',
                body: JSON.stringify({
                    uuid: props.userUuid,
                    is_admin: isAdmin
                })
            });
            if (fetchId !== fetchIdRef.current) {
                // There was another query since, ignore
                return;
            }
            if (response.status === 200) {
                const jsonData = yield response.json();
                if (jsonData.status === 'success') {
                    setModified(false);
                }
            }
            // TODO Handle any other status or return code, the data was not saved!
        }
        catch (error) {
            console.error(`Error updating user: ${error}`);
        }
        finally {
            setLoading(false);
        }
    }), []);
    const updateValue = (value) => {
        setIsAdmin(value);
        setModified(true);
    };
    // Do not allow a user to set or unset admin for himself
    const disabled = user !== undefined && user !== null && user.id === props.userId;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(InputCheckbox_1.InputCheckboxBoolean, { id: `userIsAdmin_${props.userUuid}`, isChecked: isAdmin, defaultChecked: isAdmin, disabled: disabled, onValueChange: (e) => updateValue(e.target.value) }),
        modified && !disabled && (react_1.default.createElement(Button_1.Button, { icon: loading ? faCircle_1.faCircle : faCheckCircle_1.faCheckCircle, iconClass: "_icon-alone", size: "small", label: "", title: t('admin:user:ApplyChanges'), onClick: loading ? undefined : () => updateCurrentUser(isAdmin) }))));
};
exports.default = WidgetSetAdmin;
//# sourceMappingURL=WidgetSetAdmin.js.map